// src/pages/admin/Inventario.js
import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const fmtCOP = v => new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0}).format(v||0);

export default function Inventario() {
  const [productos, setProductos] = useState([]);
  const [modal, setModal] = useState(null);
  const [ajuste, setAjuste] = useState({ tipo:'entrada', cantidad:'', motivo:'' });

  const load = () => api.get('/inventario').then(r => setProductos(r.data)).catch(()=>{});
  useEffect(() => { load(); }, []);

  const hacerAjuste = async () => {
    if (!ajuste.cantidad) return toast.error('Ingresa la cantidad');
    try {
      await api.post('/inventario/ajuste', { producto_id: modal.id, ...ajuste, cantidad: parseInt(ajuste.cantidad) });
      toast.success('Inventario actualizado ✅');
      setModal(null);
      load();
    } catch (err) { toast.error(err.response?.data?.error || 'Error'); }
  };

  return (
    <div>
      <div style={{ background:'#fff', borderBottom:'1px solid var(--border)', padding:'14px 28px', display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:10 }}>
        <h1 style={{ fontSize:18, fontWeight:900, color:'var(--forest)' }}>Inventario</h1>
      </div>
      <div style={{ padding:'24px 28px' }}>
        <div className="card">
          <table className="table">
            <thead><tr><th>Producto</th><th>SKU</th><th>Stock actual</th><th>Nivel</th><th>Mínimo</th><th>Costo unit.</th><th>Estado</th><th></th></tr></thead>
            <tbody>
              {productos.map(p => {
                const pct = Math.min(100, Math.round(p.stock / Math.max(p.stock_minimo * 3, 1) * 100));
                const color = p.stock <= p.stock_minimo ? 'var(--red)' : p.stock <= p.stock_minimo * 2 ? 'var(--yellow)' : 'var(--green)';
                return (
                  <tr key={p.id}>
                    <td style={{ fontWeight:700 }}>{p.nombre}</td>
                    <td style={{ fontSize:12, color:'var(--text-muted)' }}>{p.sku}</td>
                    <td style={{ fontWeight:900, fontSize:16, color: p.stock <= p.stock_minimo ? 'var(--red)' : 'var(--forest)' }}>{p.stock}</td>
                    <td style={{ width:120 }}>
                      <div style={{ height:6, background:'var(--cream-dark)', borderRadius:3, overflow:'hidden' }}>
                        <div style={{ height:'100%', width:`${pct}%`, background:color, borderRadius:3 }} />
                      </div>
                    </td>
                    <td style={{ fontSize:12 }}>{p.stock_minimo}</td>
                    <td style={{ fontSize:12 }}>{fmtCOP(p.costo)}</td>
                    <td>
                      <span className={`badge ${p.stock <= p.stock_minimo ? 'badge-red' : p.stock <= p.stock_minimo*2 ? 'badge-yellow' : 'badge-green'}`}>
                        {p.stock <= p.stock_minimo ? '⚠️ Stock bajo' : p.stock <= p.stock_minimo*2 ? 'Medio' : 'OK'}
                      </span>
                    </td>
                    <td>
                      <button className="btn btn-outline btn-sm" onClick={() => { setModal(p); setAjuste({ tipo:'entrada', cantidad:'', motivo:'' }); }}>Ajustar</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {modal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:100, display:'flex', alignItems:'center', justifyContent:'center' }}>
          <div style={{ background:'#fff', borderRadius:16, width:380, padding:28 }}>
            <h2 style={{ fontSize:16, fontWeight:800, marginBottom:4, color:'var(--forest)' }}>Ajustar inventario</h2>
            <p style={{ fontSize:13, color:'var(--text-muted)', marginBottom:20 }}>{modal.nombre} — Stock actual: <strong>{modal.stock}</strong></p>
            <div className="form-group">
              <label className="form-label">Tipo de movimiento</label>
              <select className="form-input" value={ajuste.tipo} onChange={e=>setAjuste(a=>({...a,tipo:e.target.value}))}>
                <option value="entrada">➕ Entrada (compra de insumos)</option>
                <option value="salida">➖ Salida (pérdida, daño)</option>
                <option value="ajuste">🔄 Ajuste directo</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">{ajuste.tipo === 'ajuste' ? 'Nuevo stock total' : 'Cantidad'}</label>
              <input className="form-input" type="number" min="0" value={ajuste.cantidad} onChange={e=>setAjuste(a=>({...a,cantidad:e.target.value}))} placeholder="0" />
            </div>
            <div className="form-group">
              <label className="form-label">Motivo</label>
              <input className="form-input" value={ajuste.motivo} onChange={e=>setAjuste(a=>({...a,motivo:e.target.value}))} placeholder="Ej: Compra de insumos, conteo físico..." />
            </div>
            <div style={{ display:'flex', gap:10, marginTop:8 }}>
              <button className="btn btn-primary" style={{ flex:1 }} onClick={hacerAjuste}>Guardar ajuste</button>
              <button className="btn btn-outline" onClick={() => setModal(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
